export const getIsInRange = (
  data?: number,
  normMin?: number,
  normMax?: number
) => {
  if (!data) {
    return true;
  }

  if (!normMin && !normMax) {
    return true;
  }

  const hasCorrectMin = normMin === undefined || normMin <= data;
  const hasCorrectMax = normMax === undefined || normMax >= data;

  return hasCorrectMin && hasCorrectMax;
};
